<app-card icon="refresh" title="Cancel & Change Statistics" subtitle="Cancellation and change performance by agent" iconGradient="from-red-500 to-pink-600" class="h-full">
    <ng-template #headerTemplate>
        <div class="ml-auto">
            <app-excel-button
                [data]="exportData()"
                [excelTitle]="'agent-reservation-cancel-and-change'"
                [columns]="cols"
            ></app-excel-button>
        </div>
    </ng-template>
    <app-table-component
        [cols]="cols"
        [data]="agentBiStatisticData() || []"
        [loading]="loading()"
    ></app-table-component>
</app-card>

<ng-template #agentCellTemplate let-rowData="rowData">
    <div class="agent-cell">
        <span class="mini-avatar">{{ getInitials(rowData.agentName) }}</span>
        <strong>{{ rowData.agentName }}</strong>
    </div>
</ng-template>

<ng-template #cancelBadgeTemplate let-rowData="rowData">
    <span class="cancel-badge">{{ rowData.reservationCancel }}</span>
</ng-template>

<ng-template #changeBadgeTemplate let-rowData="rowData">
    <span class="change-badge">{{ rowData.voluntaryFlightCancel }}</span>
</ng-template>
